var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6825 24.5L0 29.75V2C0 1.60218 0.158035 1.22064 0.43934 0.93934C0.720644 0.658035 1.10218 0.5 1.5 0.5H28.5C28.8978 0.5 29.2794 0.658035 29.5607 0.93934C29.842 1.22064 30 1.60218 30 2V23C30 23.3978 29.842 23.7794 29.5607 24.0607C29.2794 24.342 28.8978 24.5 28.5 24.5H6.6825ZM5.6445 21.5H27V3.5H3V23.5775L5.6445 21.5ZM13.5 11H16.5V14H13.5V11ZM7.5 11H10.5V14H7.5V11ZM19.5 11H22.5V14H19.5V11Z",
    fill: "#525866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIcon);
export default __webpack_public_path__ + "static/media/sms-icon.48ae28afd1d3aa4aa5ae4771a27e5843.svg";
export { ForwardRef as ReactComponent };